<template>
  <div style="padding: 0px 20px">
    <a-row :gutter="20">
      <a-col :span="24">
        <a-tabs :default-active-key="tabKey" @change="handleTabChange">
          <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
            <TableList
              :columns="item.columns"
              :tableData="item.tableData"
              :loading="item.loading"
              :scroll="{}"
              :pagination="item.pagination"
              @change="changeLeftTable"
            >
              <!-- 内容插槽部分 -->
              <template slot="emotionalState" slot-scope="{ record }">
                <div>
                  <img
                    style="width: 20px; height: 20px"
                    :src="
                      require(`@assets/schoolChangeTrend/${renderPhizIcon(
                        record.emotionalState
                      )}.png`)
                    "
                  />
                  <span style="margin-left: 4px">
                    {{
                      record.emotionalState == 1
                        ? '开心'
                        : record.emotionalState == -1
                        ? '不开心'
                        : '正常'
                    }}
                  </span>
                </div>
              </template>
              <template slot="warnFlag" slot-scope="{ record }">
                <img
                  v-if="record.warnFlag == 1"
                  style="width: 20px; height: 20px"
                  :src="require(`@assets/schoolChangeTrend/forewarning.png`)"
                />
              </template>
              <template slot="action" slot-scope="{ record }">
                <span class="action-detail" @click="viewArchives(record)">查看档案</span>
              </template>
            </TableList>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>
    <ViewPhoto ref="viewPhotoRef" />
  </div>
</template>

<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { getStoreHttpUrl } from '@/utils/util'
import ViewPhoto from './components/ViewPhoto.vue'

const tabPagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'StudentStatusRecord',
  components: {
    TableList,
    ViewPhoto,
  },
  props: {
    classId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryParam: {},
      tabPaneConfig: [
        {
          tab: '愉悦人数',
          key: 1,
          columns: [
            {
              title: '序号',
              align: 'center',
              dataIndex: 'index',
            },
            {
              title: '在校瞬间',
              align: 'center',
              dataIndex: 'studentPic',
              customRender: (_, record) => {
                return (
                  <img
                    src={getStoreHttpUrl(record.studentPic)}
                    style="width: 40px; height: 40px;border-radius: 4px;"
                    onClick={() => this.viewPhoto(record)}
                  />
                )
              },
            },
            {
              title: '姓名',
              align: 'center',
              dataIndex: 'name',
            },
            {
              title: '关爱级别',
              align: 'center',
              dataIndex: 'careList',
            },
            {
              title: '昨日心情',
              align: 'center',
              dataIndex: 'emotionalState',
              scopedSlots: { customRender: 'emotionalState' },
            },
            {
              title: '提醒次数',
              align: 'center',
              dataIndex: 'warnNum',
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tabPagination },
        },
        {
          tab: '提醒人数',
          key: 2,
          columns: [
            {
              title: '序号',
              align: 'center',
              dataIndex: 'index',
            },
            {
              title: '姓名',
              align: 'center',
              dataIndex: 'name',
            },
            {
              title: '关爱级别',
              align: 'center',
              dataIndex: 'careList',
            },
            {
              title: '昨日心情',
              align: 'center',
              dataIndex: 'emotionalState',
              scopedSlots: { customRender: 'emotionalState' },
            },
            {
              title: '状态',
              dataIndex: 'warnFlag',
              align: 'center',
              scopedSlots: { customRender: 'warnFlag' },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tabPagination },
        },
        {
          tab: '关爱人数',
          key: 3,
          columns: [
            {
              title: '序号',
              align: 'center',
              dataIndex: 'index',
            },
            {
              title: '姓名',
              align: 'center',
              dataIndex: 'name',
            },
            {
              title: '关爱级别',
              align: 'center',
              dataIndex: 'careList',
            },
            {
              title: '昨日心情',
              align: 'center',
              dataIndex: 'emotionalState',
              scopedSlots: { customRender: 'emotionalState' },
            },
            {
              title: '状态',
              dataIndex: 'warnFlag',
              align: 'center',
              scopedSlots: { customRender: 'warnFlag' },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tabPagination },
        },
      ],
      tabKey: 1,
      currRowInfo: {},
    }
  },
  created() {
    this.getClassMood()
  },
  methods: {
    changeLeftTable(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.getClassMood()
    },
    getClassMood() {
      if (!this.classId) return
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      getAction('/statistic/classDetails', {
        classId: this.classId,
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        type: this.tabKey,
      })
        .then((res) => {
          if (res.success) {
            const tableData = res.result.records.map((item, index) => ({
              ...item,
              index: index + 1,
            }))
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
          }
        })
        .catch((err) => {
          console.log('err--', err)
        })
    },
    handleTabChange(key) {
      this.tabKey = key
      this.getClassMood()
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    // 渲染表情
    renderPhizIcon(status) {
      return status == 1
        ? 'happy-phiz'
        : status == -1
        ? 'unhappy-phiz'
        : status == 0
        ? 'normal-phiz'
        : 'warning-phiz'
    },
    viewPhoto(record) {
      console.log('record', record)
      this.$refs.viewPhotoRef.showModal(record)
    },
  },
}
</script>

<style scoped lang="less">
.action-detail {
  color: #0077fa !important;
  cursor: pointer !important;
}
::v-deep {
  .ant-tabs-nav-scroll {
    width: 100% !important;
    display: flex !important;
  }
  .ant-tabs-nav {
    display: flex !important;
    width: 100% !important;
  }
  .ant-tabs-ta {
    width: 33.33% !important;
  }
}
</style>
